var _rect, _rect2, _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLockLarge = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 44,
  height: 44,
  viewBox: "0 0 44 44",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 44,
  height: 44,
  rx: 22,
  fill: "currentColor"
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  x: 12,
  y: 21,
  width: 20,
  height: 14,
  rx: 2,
  stroke: "white",
  strokeWidth: 2.5
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M15.5 21V14C15.5 10.9624 17.9624 8.5 21 8.5H23C26.0376 8.5 28.5 10.9624 28.5 14V21",
  stroke: "white",
  strokeWidth: 2.5,
  strokeLinecap: "round"
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 22,
  cy: 28,
  r: 2,
  fill: "white"
})));
export default SvgLockLarge;